// src/store/slices/case.slice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Case, CaseApiResponse } from "@/interface/case.interface";
import axiosInstance from "@/lib/axios";

export const fetchCases = createAsyncThunk<Case[]>(
  "cases/fetchCases",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<CaseApiResponse>(
        "/case"
      );
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

interface CaseState {
  cases: Case[];
  loading: boolean;
  error: string | null;
}

const initialState: CaseState = {
  cases: [],
  loading: false,
  error: null,
};

const caseSlice = createSlice({
  name: "cases",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCases.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCases.fulfilled, (state, action) => {
        state.loading = false;
        state.cases = action.payload;
      })
      .addCase(fetchCases.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default caseSlice.reducer;
